export default "__VITE_ASSET__7ff6b582__"